const LOGIN = {
  CARD_TITLE: "Login to chat app",
  LOGIN: "Login",
  EMAIL_PH: "Email",
  PASSWORD_PH: "Password",
  FORGET_PASS_TEXT: "Forgot your password ?",
  CLICK: "Click here",
  ONE_TIME_VERIFICATION_LOGIN: "Login with One-Time Verification Code!",
};

export default LOGIN;
